import { cifrarAES } from "../../../../utils/cryptoUtils";
import fetchData from "../../../../utils/fetchData";
import { decryptAES } from "../../../PinesCrc/utils/cryptoUtils";


const URL =`${process.env.REACT_APP_URL_BANCO_AGRARIO}/banco-agrario/electronic-tally/paginated`;

export const postPaginatedElectronicTally = async (bodyObj) => {
  if (!bodyObj) return "Sin datos body";

  const encryptedData = cifrarAES(
    process.env.REACT_APP_LLAVE_AES_ENCRYPT_CORRESPONSALIA_OTROS,
    process.env.REACT_APP_IV_AES_ENCRYPT_CORRESPONSALIA_OTROS,
    JSON.stringify(bodyObj)
  );

  const res = await fetchData(
    URL,
    "POST",
    {},
    { data: encryptedData },
    {},
    true
  );
  try {
    const dataDecrypt = res?.obj?.data ?? "";
    const obj = decryptAES(
      `${process.env.REACT_APP_LLAVE_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
      `${process.env.REACT_APP_IV_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
      dataDecrypt
    );
    res.obj = JSON.parse(obj);
  } catch (error) {
    console.error(`No se puede desencriptar`);
    throw error;
  }
  return res.obj

};
export const postGetSupportElectronicTally = async (bodyObj) => {
  if (!bodyObj) return "Sin datos body";

  const encryptedData = cifrarAES(
    process.env.REACT_APP_LLAVE_AES_ENCRYPT_CORRESPONSALIA_OTROS,
    process.env.REACT_APP_IV_AES_ENCRYPT_CORRESPONSALIA_OTROS,
    JSON.stringify(bodyObj)
  );

  const res = await fetchData(
    `${process.env.REACT_APP_URL_BANCO_AGRARIO}/banco-agrario/electronic-tally/get-support`,
    "POST",
    {},
    { data: encryptedData },
    {},
    true
  );

  try {
    const dataDecrypt = res?.obj?.data ?? "";
    const obj = decryptAES(
      `${process.env.REACT_APP_LLAVE_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
      `${process.env.REACT_APP_IV_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
      dataDecrypt
    );
    res.obj = JSON.parse(obj);
  } catch (error) {
    console.error(`No se puede desencriptar`);
    throw error;
  }
  return res.obj
};
